window.c24LpFrameJsReady.then(function() {
    window.Check24 = window.Check24 || {};

    window.Check24.yellowBoxDropdown = {

        init: function () {
            window.Check24.yellowBoxDropdown.dropdown = document.querySelectorAll('.c24-yellow-dropdown');
            window.Check24.yellowBoxDropdown.dropdownInputWrapper = document.querySelectorAll('.c24-dropdown-input-container');
            window.Check24.yellowBoxDropdown.dropdownInput = document.querySelectorAll('.c24-yellow-dropdown-input');
            window.Check24.yellowBoxDropdown.dropdownOptionsWrapper = document.querySelectorAll('.c24-yellow-dropdown-options');
            window.Check24.yellowBoxDropdown.dropdownOptions = document.querySelectorAll('.c24-option');
            window.Check24.yellowBoxDropdown.arrow = document.querySelector('.c24-yellow-dropdown .c24-dropdown-arrow');
            window.Check24.yellowBoxDropdown.handleToggleDropdown();
            window.Check24.yellowBoxDropdown.select();
            window.Check24.yellowBoxDropdown.selectDefault();

            window.Check24.yellowBoxDropdown.dropdown.forEach(function (ele) {
                const placeholder = ele.querySelector('.c24-dropdown-placeholder');
                if (placeholder === undefined || placeholder === null) {
                    ele.querySelector('.c24-yellow-dropdown-input').classList.remove('placeholder');
                }
            });
        },
        handleToggleDropdown: function () {
            window.Check24.yellowBoxDropdown.dropdown.forEach(function (ele) {
                document.addEventListener('click', function (e) {
                    window.Check24.hide('.c24-dropdown-placeholder');
                    if (!ele.classList.contains('active') &&
                    !e.target.closest('.c24-yellow-dropdown-options') &&
                    (e.target === window.Check24.yellowBoxDropdown.arrow || e.target === ele.querySelector('.c24-yellow-dropdown-input'))) {
                        ele.classList.add('active');
                    } else {
                        ele.classList.remove('active');
                    }
                });
            });
        },
        handleSelectListItem: function (ele, currentTarget) {
            if (!ele || !currentTarget) {
                return;
            }
            ele.closest('.c24-yellow-dropdown').classList.remove('active');
            if (currentTarget.classList.contains('c24-option')) {
                let wrapperElem = currentTarget.closest('.c24-yellow-dropdown');
                let option = currentTarget.closest('.c24-option');
                let options = ele.querySelectorAll('.c24-option');
                options.forEach((ele) => {
                    ele.classList.remove('selected');
                });
                option.classList.add('selected');
                let inputEle = wrapperElem.querySelector('.c24-yellow-dropdown-input');
                let hiddenInputEle = wrapperElem.querySelector('.c24-yellow-dropdown-hidden-input');
                if (!wrapperElem && !inputEle) {
                    return;
                }
                inputEle.value = option.innerText;
                inputEle.classList.remove('placeholder');
                hiddenInputEle.value = option.dataset.value;
                hiddenInputEle.dispatchEvent(new Event('change'));
            }
        },
        select: function () {
            window.Check24.yellowBoxDropdown.dropdownOptionsWrapper.forEach(function (ele) {
                ele.addEventListener('click', function (event) {
                    window.Check24.yellowBoxDropdown.handleSelectListItem(ele, event.target);
                });

                let currentFocus;
                currentFocus = -1;

                document.addEventListener('keydown', function (e) {
                    if (!ele.closest('.c24-yellow-dropdown').classList.contains('active')) {
                        return;
                    }
                    e.preventDefault();

                    const itemList = document.querySelector('.c24-yellow-dropdown-options');
                    let items = itemList.querySelectorAll('.c24-option');

                    if (currentFocus === items.length) {
                        currentFocus = -1;
                    }

                    if (e.keyCode === 40) {
                        currentFocus++;
                        window.Check24.yellowBoxDropdown.activateList(items, currentFocus);
                    } else if (e.keyCode === 38) {
                        currentFocus--;
                        window.Check24.yellowBoxDropdown.activateList(items, currentFocus);
                    } else if (e.keyCode === 13) {
                        e.preventDefault();
                        if (currentFocus > -1) {
                            window.Check24.yellowBoxDropdown.handleSelectListItem(ele, items[currentFocus]);
                        } else {
                            window.Check24.yellowBoxDropdown.handleSelectListItem(ele, items[0]);
                        }
                    }
                });
            });
        },
        activateList: function(items, currentFocus) {
            if (!items) {
                return false;
            }
            window.Check24.yellowBoxDropdown.deactivateList(items);

            if (currentFocus >= items.length) {
                currentFocus = 0;
            }
            if (currentFocus < 0) {
                currentFocus = items.length - 1;
            }

            items[currentFocus].classList.add('active');
        },
        deactivateList: function(items) {
            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove('active');
            }
        },
        selectDefault: function () {
            window.Check24.yellowBoxDropdown.dropdownOptionsWrapper.forEach(function (ele) {
                let wrapperElem = ele.closest('.c24-yellow-dropdown');
                let input = wrapperElem.querySelector('.c24-yellow-dropdown-input');
                let hiddenInputEle = wrapperElem.querySelector('.c24-yellow-dropdown-hidden-input');
                let selectedOption = ele.querySelector('.c24-option.selected');
                if (selectedOption) {
                    input.value = selectedOption.innerHTML;
                    input.dataset.value = selectedOption.dataset.value;
                    hiddenInputEle.value = selectedOption.dataset.value;
                }
                if (input.dataset.value === '') {
                    input.classList.add('placeholder');
                }
                if (ele.hasAttribute('data-callback')) {
                    let callbackField = ele.closest('.c24-select-dropdowns').dataset.callback;
                    if (callbackField) {
                        let triggerInputChange = () => {
                            hiddenInputEle.dispatchEvent(new Event('change'));
                        };
                        if (typeof triggerInputChange === 'function') {
                            triggerInputChange();
                        }
                    }
                }
            });
        },
    };
});

window.c24DomReady(function() {
    window.c24LpFrameJsReady.then(function() {
        window.c24LpCssLoaded.then(function() {
            window.Check24.yellowBoxDropdown.init();
        });
    });
});
